import { Loader } from '../Loader/Loader';

export function GenericLoadingFallback() {
  return <Loader height={'100%'} />;
}
